import {css} from "@panda/css";

import {Link} from "@pg-design/link-module";
import {Text} from "@pg-design/text-module";

import {useResponsiveLinkTarget} from "../hooks/use_responsive_link_target";

interface IProps {
    href?: string;
    label: string;
    linkText: string;
    dataTestId?: string;
}

export const LinkWithLabel = (props: IProps) => {
    const {href, label, linkText, dataTestId} = props;

    const target = useResponsiveLinkTarget();

    const Element = href ? Link : Text;

    return (
        <div className={linkWithLabel} data-testid={dataTestId}>
            <div className={flexWrapper}>
                <Text variant="info_txt_1" color="var(--colors-gray-700)">
                    {label}
                </Text>

                <Element href={href} variant="info_txt_1" size="small" target={target} textClassName={linkTextStyle}>
                    {linkText}
                </Element>
            </div>
        </div>
    );
};

const linkWithLabel = css({
    display: "flex",
    alignItems: "center",
    mb: "0.5rem"
});

const flexWrapper = css({
    display: "flex",
    alignItems: "center",
    gap: "0.3rem"
});

const linkTextStyle = css({
    display: "flex",
    textDecoration: "underline"
});
